<dl class="hvac-product-property-list">
    <ng-content select="hvac-product-property-list-item"></ng-content>
</dl>
